import * as e from 'react';
import { forwardRef, memo } from 'react';

var n=({title:r,titleId:t,...o},l)=>e.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:l,"aria-labelledby":t,...o},r?e.createElement("title",{id:t},r):null,e.createElement("path",{d:"m10 3.38.71.71L6.75 8l3.92 3.91-.71.71L5.33 8Z"})),i=forwardRef(n),m=memo(i),G=m;

export { G as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-4H6CL2NL.mjs.map